import axios from 'axios';
import {
  TypeVendorInfo,
  TypeWorkingBudgetInfo
} from '../types/WorkingBudgetPage';
import { updateLedger } from './ledger';

/**
 * 実行予算の詳細取得
 */
export const getWorkingBudget = (workingBudgetId: number) => {
  return axios
    .get(`/api/v1/working_budget/${workingBudgetId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 工事の情報取得
 */
export const getConstructsInfo = (workingBudgetId: number) => {
  return axios
    .get(`/api/v1/constructs/info/${workingBudgetId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 実行予算の各金額情報取得
 */
export const getWorkingBudgetInfo = (workingBudgetId: number) => {
  return axios
    .get(`/api/v1/workingBudgetInfo/${workingBudgetId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 実行予算更新
 */
export const updateWorkingBudget = (data: any, workingBudgetId: number) => {
  return axios
    .post(`/api/v1/working_budget/update/${workingBudgetId}`, data, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 業者の追加
 */
export const addVender = (data: TypeVendorInfo, workingBudgetId: number) => {
  return axios
    .post(`/api/v1/add/working_budget_vender/${workingBudgetId}`, data, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 業者の削除
 */
export const deleteWorkingBudgetVender = (
  data: any,
  workingBudgetId: number
) => {
  return axios
    .post(`/api/v1/delete/working-budget-vender/${workingBudgetId}`, data, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 追加原価の行の削除
 */
export const deleteWorkingBudgetSelectAdditionalCost = (
  data: any,
  workingBudgetId: number
) => {
  return axios
    .post(
      `/api/v1/delete/working-budget-additional-cost/${workingBudgetId}`,
      data,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 追加原価の行の追加
 */
export const addWorkingBudgetSelectAdditionalCost = (
  data: any,
  workingBudgetId: number
) => {
  return axios
    .post(
      `/api/v1/add/working-budget-additional-cost/${workingBudgetId}`,
      data,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
/**
 * 集計データ更新
 */
export const updateTotallingInfo = (
  data: TypeWorkingBudgetInfo,
  workingBudgetId: number
) => {
  return axios
    .post(`/api/v1/update/totalling-info/${workingBudgetId}`, data, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
